<template>
  <div class="voluntary-activies">
    <div class="p-top">
      <div class="p-left" @click="backHome">
        <img :src="require('@/assets/img/common/back_home@2x.png')" alt="" class="p-image-home" />
        <div class="p-backtips">返回首页</div>
      </div>
      <div class="p-arrow-tips"> > </div>
      <div class="p-map-tips" >志愿组织</div>
    </div>
    <div class="voluntary-activies-top">
      <div class="vat-area">
        <div class="vat-area-left">区域：</div>
        <div class="vat-area-right">
          <div class="vat-area-right-item" @click="selectButton1(index,item._id)" :class="selectAreaIndex==index?'selectedArea':'no-selectedArea'" v-for="(item,index) in area" :key="index">{{item.name}}</div>
        </div>
      </div>
      <div class="vat-area">
        <div class="vat-area-left">
          全部类型：
        </div>
        <div  class="vat-area-right">
          <div class="vat-area-right-item" @click="selectButton2(index,item._id)" :class="selectTypeIndex==index?'selectedArea':'no-selectedArea'" v-for="(item,index) in allType" :key="index">{{item.name}}</div>
        </div>
      </div>
      <div class="vat-search">
        <div class="vat-search-left">
          组织名称
        </div>
        <div class="nect-search-content">
          <a-input v-model="inputValue" placeholder="请输入全部名称" style="width: 410px"/>
          <div class="nect-search-button" @click="search">搜索</div>
        </div>

      </div>
    </div>
    <div class="voluntary-activies-content">
      <div v-for="(item,index) in list" :key="index" class="vac" @click="toDetail(item)">
        <div class="vac-all">
          <div  class="vac-image">
            <img :src="require('@/assets/img/volunteer/zyava.jpeg')" alt="" v-if="item.avatar==null ">
            <img :src="require('@/assets/img/volunteer/zyava.jpeg')" alt="" v-if="item.avatar=='' ">
            <img :src="item.avatar" alt="" v-else>
          </div>
          <div class="vac-title">{{item.title}}</div>
          <div class="vac-address"><img src="../../../assets/img/common/icon_dizhi@2x.png" alt="">{{item.province_name}}{{item.city_name}}{{item.county_name}}</div>
          <div class="vac-bottom">
            <div class="vac-bottom-1"><p class="p-top1">{{item.hours}}</p><p class="p-bottom">信用时数</p></div>
            <div class="vac-bottom-1"><p class="p-top1">{{item.person}}</p><p class="p-bottom">组织人数</p></div>
          </div>
        </div>
      </div>
    </div>
    <a-pagination :default-current="1" :total="total"  @change="onShowSizeChange" />

  </div>
</template>

<script>
export default {
  data(){
    return{
      inputValue:"",
      area:{name:'全市',_id:''},
      allType:{name:'全部',_id:''},
      allStatus:['全部','招募中','已结束'],
      list:[],
      selectAreaIndex:0,
      selectTypeIndex:0,
      countyId:'',
      categoryId:'',
      zyzid:'',
      total:0,
      pageParam:{
        page:1,
        rows:12
      }
    }
  },
  mounted() {
    this.getAreaType()
    //this.getOrginizeType()
    this.getList()
    this.zyzid = localStorage.getItem('jz_vol_zyzid');

  },
  methods:{
    onShowSizeChange(e){
      this.pageParam.page=e
      this.getList()
    },
    backHome() {
      this.$router.replace({ path: "/" });
    },
    toDetail(item){
      if(!this.zyzid){
        this.$message.info('您还没有登录哦～')
        this.$router.push('/login')
        return
      }
      this.$router.push(`/voluntary-organization/detail/${item.departmentid}`)
    },
    search(){
      this.$api.vmsapi
          .recruitOrgList({
            search_title:this.inputValue,
            ordertype:1,
            isUnNeedTotal:false,
            city:process.env.VUE_APP_deptId,//"1476084112357207a08eba11e682992c56dcba85b9",
            page:this.pageParam.page,
            rows:this.pageParam.rows,
          }).then(res=>{
            this.list=[]
            this.list=res.data
      })
    },
    getList(){
      this.$api.vmsapi
          .recruitOrgList({
            isUnNeedTotal:false,
            ordertype:1,
            page:this.pageParam.page,
            rows:this.pageParam.rows,
            city:process.env.VUE_APP_deptId,//"1476084112357207a08eba11e682992c56dcba85b9",
            county:this.countyId,
            category:this.categoryId
          })
          .then(res=>{
            this.allType={name:'全部',_id:''},
            this.allType=[this.allType,...res.category]
            this.list=res.data
            console.log(res,'org1')
            this.total = res.totoalcount
          })
    },
    //获取区域选项
    getAreaType(){
      this.$api.vmsapi
          .getArea(process.env.VUE_APP_deptId)
          .then(res=>{
         //   console.log(res)
            this.area = [this.area,...res]
          })
    },

    selectButton1(i,id){
      this.selectAreaIndex=i
      this.countyId=id
      this.list=[]
      this.getList()
    },
    selectButton2(i,id){
      this.selectTypeIndex=i
      this.categoryId=id
      this.list=[]
      this.getList()
    },

  }
}
</script>

<style lang="scss" scoped>

.p-top {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 16px;
  margin-bottom: 57px;
  .p-left {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #222222;
    line-height: 16px;
    .p-image-home {
      width: 26px;
      height: 26px;
      margin-right: 6px;
    }
  }
  .p-arrow-tips {
    margin: 0 5px;
  }
  .p-map-tips {
    cursor: pointer;
    color: #CD3232;
  }
}

.selectedArea{
  color:red;
}
.no-selectedArea{
  color:black;
}
.voluntary-activies{

  width: 1200px;
  position: relative;
  left:50%;
  transform: translateX(-50%);
  margin-top:20px ;
  margin-bottom: 40px;
  .voluntary-activies-top{
    padding:20px;
    background: #FFFFFF;
    margin-bottom: 20px;
    .vat-area{
      display: flex;
      margin-bottom: 10px;
      .vat-area-left{
        width: 140px;
      }
      .vat-area-right{
        display: flex;
        flex-wrap: wrap;
        width: 1000px;
        .vat-area-right-item{
          margin-right: 20px;
        }
      }

    }
    .vat-search{
      margin-top: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .vat-search-left{
        margin-right: 20px;
        width: 120px;
      }
      .nect-search-content{
        display: flex;
        flex-direction: row;
        align-items: center;
        .nect-search-button{
          margin-left: 20px;
          width: 90px;
          height: 32px;
          background: #CD3232;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          font-family: Helvetica;
          color: #FFFFFF;
          line-height: 14px;
        }
      }
    }
  }
  .voluntary-activies-content{
    margin-top: 20px;
    display: grid;
    grid-template-columns: repeat(4,300px);
    .vac{
      height:280px;
      margin-bottom: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space:nowrap;
      .vac-all{
        background: #FFFFFF;
        width: 288px;
        height:280px;
        padding-top: 10px;

        .vac-image{
          width: 288px;
          height: 150px;
          display: table-cell;
          vertical-align: middle;
          //
          //display: flex;
          //align-items: center;
          //justify-content: center;
          img{
            //margin-top: 20px;
            //height: 100%;
            max-width: 100%;
            max-height: 100%;
            display: block;
            margin: auto;
          }
        }

        .vac-title{
          text-align: left;
          padding: 0 10px;
          margin-top: 16px;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 18px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space:nowrap;
        }
        .vac-address{
          padding: 0 10px;

          margin-top: 10px;
          font-size: 12px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #666666;
          line-height: 12px;
          display: flex;
          flex-direction: row;
          img{
            width: 10px;
            height: 10px;
            margin-right: 10px;
          }
        }
      }

      .vac-bottom{
        margin-top: 12px;
        display: flex;
        flex-direction: row;justify-content: center;
        align-items: center;

        .vac-bottom-1{
          display: flex;
          flex-direction: column;
          height: 62px;

          border-top: 2px solid #f3f2f2;
          border-bottom:2px solid #f3f2f2;
          border-left:2px solid #f3f2f2;
          border-right:2px solid #f3f2f2;
          justify-content: center;
          .p-top1{

            width: 144px;
            display: flex;
            justify-content: center;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
            line-height: 22px;
          }
          .p-bottom{
            width: 144px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 14px;
          };
        }

      }
    }
  }
}
</style>